import React from 'react';
import './Footer.css';


import logo from '../assets/images/Group 1171274926.png';
import linkedinIcon from '../assets/icons/Linkedin Icon.png';
import facebookIcon from '../assets/icons/Facebook Icon.png';
import instagramIcon from '../assets/icons/Linkedin Icon.png';

const Footer = () => {
  return (
    <footer className="footer">
      {}
      <div className="footer-curve">
        <svg viewBox="0 0 1440 150" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#f1f3f6"
            d="M0,64 C480,192 960,0 1440,128 L1440,320 L0,320 Z"
          />
        </svg>
      </div>

      <div className="footer-content">
        <div className="footer-logo-section">
          <img src={logo} alt="Daily App Hub Logo" className="footer-logo" />
          <p>
            DailyAppHub is the product arm of byteeIT, developing a suite of AI-driven apps for everyday use.
          </p>
          <p className="social-text">Follow Us</p>
          <div className="social-icons">
            <img src={facebookIcon} alt="Facebook" />
            <img src={linkedinIcon} alt="LinkedIn" />
            <img src={instagramIcon} alt="Twitter" />
          </div>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <h4>Home</h4>
            <a href="#about">About</a>
            <a href="#why-us">Why Us</a>
            <a href="#contact">Contact Us</a>
          </div>
          <div className="footer-column">
            <h4>Product</h4>
            <a href="#products">EbizCard</a>
          </div>
          <div className="footer-column">
            <h4>Contact Info</h4>
            <p>SRTP Office, Block B-B35-199, Sharjah, UAE</p>
            <p>J-1008, Prateek Laurel, Noida, UP, India</p>
            <p>+971 58 845 9739</p>
            <p>reachus@dailyapphub.com</p>
          </div>
        </div>
      </div>

      <p className="footer-copyright">
        © 2024 DailyAppHub. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
